import React from "react"
import { useStaticQuery, graphql } from "gatsby"
const LogoLarge = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulAllgemein(id: { eq: "a184f87a-8247-5ceb-a1ea-8811849afd31" }) {
        logo {
          localFile {
            publicURL
          }
        }
      }
    }
  `)

  return (
    <img
      src={data.contentfulAllgemein.logo.localFile.publicURL}
      alt="Leonie Freudenberger"
    />
  )
}

export default LogoLarge
